import { render, staticRenderFns } from "./CheckSwitch.vue?vue&type=template&id=23836502"
import script from "./CheckSwitch.vue?vue&type=script&lang=js"
export * from "./CheckSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports